var _path, _path2, _rect, _rect2, _path3, _rect3, _rect4, _path4, _rect5, _rect6, _path5, _rect7, _rect8, _path6, _path7, _path8, _circle, _circle2, _circle3, _circle4, _circle5, _path9, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.12 141.988c-37.13 0-67.505 30.348-67.505 67.446s30.375 67.446 67.505 67.446c7.448 0 13.549 6.095 13.549 13.537 0 7.442-6.101 13.537-13.549 13.537h-35.323c-18.113 0-32.935 14.81-32.935 32.907 0 18.098 14.822 32.907 32.935 32.907 15.666 0 28.484 12.807 28.484 28.459 0 28.557 23.386 51.922 51.967 51.922h305.063c37.13 0 67.505-30.348 67.505-67.446s-30.375-67.446-67.505-67.446h-6.53c-7.448 0-13.549-6.088-13.549-13.537 0-7.443 6.093-13.538 13.549-13.538h43.954c18.113 0 32.935-14.809 32.935-32.906 0-18.075-14.784-32.869-32.867-32.907h-35.368c-15.666 0-28.484-12.807-28.484-28.459 0-28.557-23.385-51.922-51.967-51.922H285.12z",
    fill: "url(#a)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 196.575,
    y: 233.005,
    width: 167.656,
    height: 163.739,
    rx: 33.551,
    fill: "#A3C5F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 279.738,
    y: 365.259,
    width: 35.446,
    height: 35.446,
    rx: 11.743,
    transform: "rotate(45 279.738 365.259)",
    fill: "#A3C5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.276 351.096v6.372c0 3.517-2.833 6.372-6.324 6.372h-75.881c-3.491 0-6.324-2.855-6.324-6.372v-6.474c0-19.282 21.867-31.81 44.265-31.81 22.397 0 44.264 12.534 44.264 31.81m-29.145-78.43c8.567 8.873 8.567 23.258 0 32.131-8.566 8.873-22.456 8.873-31.022 0-8.567-8.873-8.567-23.258 0-32.131 8.566-8.872 22.456-8.872 31.022 0z",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 371.96,
    y: 113.956,
    width: 167.656,
    height: 163.739,
    rx: 33.551,
    fill: "#A3C5F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 455.122,
    y: 246.21,
    width: 35.446,
    height: 35.446,
    rx: 11.743,
    transform: "rotate(45 455.122 246.21)",
    fill: "#A3C5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M499.66 232.046v6.373c0 3.517-2.833 6.372-6.323 6.372h-75.882c-3.49 0-6.323-2.855-6.323-6.372v-6.475c0-19.282 21.866-31.809 44.264-31.809 22.398 0 44.264 12.534 44.264 31.809m-29.145-78.429c8.567 8.873 8.567 23.258 0 32.131-8.566 8.872-22.455 8.872-31.022 0-8.567-8.873-8.567-23.258 0-32.131 8.567-8.872 22.456-8.872 31.022 0z",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 371.96,
    y: 311.254,
    width: 167.656,
    height: 163.739,
    rx: 33.551,
    fill: "#A3C5F0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 455.122,
    y: 443.507,
    width: 35.446,
    height: 35.446,
    rx: 11.743,
    transform: "rotate(45 455.122 443.507)",
    fill: "#A3C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M499.66 429.344v6.372c0 3.517-2.833 6.372-6.323 6.372h-75.882c-3.49 0-6.323-2.855-6.323-6.372v-6.474c0-19.282 21.866-31.81 44.264-31.81 22.398 0 44.264 12.534 44.264 31.81m-29.145-78.43c8.567 8.873 8.567 23.258 0 32.131-8.566 8.873-22.455 8.873-31.022 0s-8.567-23.258 0-32.131c8.567-8.872 22.456-8.872 31.022 0z",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 547.344,
    y: 193.398,
    width: 167.656,
    height: 163.739,
    rx: 33.551,
    fill: "#A3C5F0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 630.506,
    y: 325.653,
    width: 35.446,
    height: 35.446,
    rx: 11.743,
    transform: "rotate(45 630.506 325.653)",
    fill: "#A3C5F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M675.045 311.489v6.372c0 3.517-2.833 6.372-6.324 6.372H592.84c-3.491 0-6.324-2.855-6.324-6.372v-6.474c0-19.282 21.867-31.81 44.264-31.81 22.398 0 44.265 12.534 44.265 31.81M645.9 232.958c8.567 8.872 8.567 23.258 0 32.13-8.567 8.873-22.456 8.873-31.023 0-8.566-8.872-8.566-23.258 0-32.13 8.567-8.873 22.456-8.873 31.023 0z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.594 168.461v-32.18c0-3.334 2.695-6.034 6.021-6.034h36.127c3.327 0 6.022 2.7 6.022 6.034v32.18a6.035 6.035 0 0 1-3.098 5.274l-18.064 10.055a6.003 6.003 0 0 1-5.849 0l-18.064-10.055a6.04 6.04 0 0 1-3.095-5.274z",
    fill: "#E1E4E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M269.667 156.857h20.025m-20.025-9.381h20.025m-20.025 18.492h20.025",
    stroke: "#fff",
    strokeWidth: 3.094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 324.753,
    cy: 431.824,
    r: 5.922,
    transform: "rotate(105 324.753 431.824)",
    fill: "#E1E4E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.27,
    cy: 209.181,
    r: 5.922,
    transform: "rotate(105 331.27 209.181)",
    fill: "#E1E4E5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.253,
    cy: 221.128,
    r: 5.922,
    transform: "rotate(105 192.253 221.128)",
    fill: "#E1E4E5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.29,
    cy: 175.513,
    r: 5.922,
    transform: "rotate(105 571.29 175.513)",
    fill: "#E1E4E5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 575.635,
    cy: 393.812,
    r: 5.922,
    transform: "rotate(105 575.635 393.812)",
    fill: "#E1E4E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M651.83 413.803h-2.897c-.701 0-1.265-.57-1.265-1.264v-2.897c0-.701.57-1.265 1.265-1.265h2.897c.694 0 1.264.57 1.264 1.265v2.897a1.262 1.262 0 0 1-1.264 1.264zm-10.044 0h-2.897a1.27 1.27 0 0 1-1.265-1.264v-2.897c0-.701.57-1.265 1.265-1.265h2.897c.694 0 1.264.57 1.264 1.265v2.897a1.27 1.27 0 0 1-1.264 1.264zm-10.051 0h-2.897a1.27 1.27 0 0 1-1.264-1.264v-2.897c0-.701.57-1.265 1.264-1.265h2.897c.695 0 1.265.57 1.265 1.265v2.897a1.262 1.262 0 0 1-1.265 1.264zm-10.044 0h-2.897a1.27 1.27 0 0 1-1.264-1.264v-2.897c0-.701.57-1.265 1.264-1.265h2.897c.701 0 1.271.57 1.271 1.265v2.897a1.279 1.279 0 0 1-1.271 1.264zm-10.044 0h-2.897a1.27 1.27 0 0 1-1.271-1.264v-2.897c0-.701.57-1.265 1.271-1.265h2.897c.694 0 1.264.57 1.264 1.265v2.897a1.27 1.27 0 0 1-1.264 1.264zm29.77-10.952h-2.896a1.27 1.27 0 0 1-1.265-1.265v-2.903c0-.694.57-1.264 1.265-1.264h2.896c.701 0 1.265.57 1.265 1.264v2.897a1.263 1.263 0 0 1-1.265 1.271zm-10.044 0h-2.897a1.27 1.27 0 0 1-1.264-1.265v-2.903c0-.694.57-1.264 1.264-1.264h2.897c.695 0 1.265.57 1.265 1.264v2.897a1.263 1.263 0 0 1-1.265 1.271zm-10.044 0h-2.897c-.7 0-1.27-.57-1.27-1.265v-2.903c0-.694.57-1.264 1.27-1.264h2.897c.694 0 1.264.57 1.264 1.264v2.897a1.27 1.27 0 0 1-1.264 1.271zm10.406 22.718h-2.897a1.27 1.27 0 0 1-1.264-1.265v-2.896c0-.701.57-1.265 1.264-1.265h2.897c.695 0 1.265.57 1.265 1.265v2.896a1.262 1.262 0 0 1-1.265 1.265zm-10.044 0h-2.897a1.27 1.27 0 0 1-1.264-1.265v-2.896c0-.701.57-1.265 1.264-1.265h2.897c.701 0 1.271.57 1.271 1.265v2.896a1.279 1.279 0 0 1-1.271 1.265z",
    fill: "#E1E4E5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 325.103,
    y: 179.782,
    width: 31.655,
    height: 3.688,
    rx: 1.844,
    transform: "rotate(-45 325.103 179.782)",
    fill: "#E1E4E5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 337.239,
    y: 179.869,
    width: 11.754,
    height: 3.688,
    rx: 1.844,
    transform: "rotate(-45 337.239 179.869)",
    fill: "#E1E4E5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 276.241,
    y: 431.61,
    width: 31.655,
    height: 3.688,
    rx: 1.844,
    transform: "rotate(135 276.241 431.61)",
    fill: "#E1E4E5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 264.104,
    y: 431.523,
    width: 11.754,
    height: 3.688,
    rx: 1.844,
    transform: "rotate(135 264.104 431.523)",
    fill: "#E1E4E5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 650.934,
    y: 153.578,
    width: 31.655,
    height: 3.688,
    rx: 1.844,
    transform: "rotate(135 650.934 153.578)",
    fill: "#E1E4E5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 638.797,
    y: 153.491,
    width: 11.754,
    height: 3.688,
    rx: 1.844,
    transform: "rotate(135 638.797 153.491)",
    fill: "#E1E4E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 471.688,
    y1: 622.922,
    x2: 465.697,
    y2: -193.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.c7dc478d7e909f9ec197decd052cc02c.svg";
export { ForwardRef as ReactComponent };